import React from 'react';
import cn from 'classnames';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

const LineLoader = ({ active }) => {
  const loaderClassName = cn('line-loader', { active });
  return <div className={loaderClassName}><div /></div>;
};

export default LineLoader;
